import React from 'react';
import '../styles/Dubai.css';
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import dubaiData from '../data/dubai.json';
import dubaiBanner from '../assets/dubai.webp';

const imageMap = {
    '../assets/burjkhalifa.png': require('../assets/burjkhalifa.png'),
        '../assets/dubaimall.png': require('../assets/dubaimall.png'),
        '../assets/palmjumeirah.png': require('../assets/palmjumeirah.png'),
        '../assets/jumeirah.png': require('../assets/jumeirah.png'),
        '../assets/dubaigarden.png': require('../assets/dubaigarden.png'),
        '../assets/alfahidi.png': require('../assets/alfahidi.png'),
        '../assets/dubai.webp': require('../assets/dubai.webp'),
        '../assets/dhow.png': require('../assets/dhow.png'),
        '../assets/aquaventure.png': require('../assets/aquaventure.png'),
        '../assets/skydiving.png': require('../assets/skydiving.png'),
        '../assets/souks.png': require('../assets/souks.png'),
        '../assets/atlantis.png': require('../assets/atlantis.png'),
        '../assets/burjal.png': require('../assets/burjal.png'),
        '../assets/addressdowntown.png': require('../assets/addressdowntown.png'),
        '../assets/fivepalm.png': require('../assets/fivepalm.png'),
        '../assets/zabeel.png': require('../assets/zabeel.png'),
        '../assets/sofitel.png': require('../assets/sofitel.png'),
        '../assets/camelsafari.png': require('../assets/camelsafari.png'),
        '../assets/falconry.png': require('../assets/falconry.png'),
        '../assets/emirati.png': require('../assets/emirati.png'),
        '../assets/firework.png': require('../assets/firework.png')


};

const Dubai = () => {
  const location = useLocation();
  return (
    <>
      {/* Header Section */}
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <a href="#" className={`contact-dropbtn ${location.pathname === '/dubai' ? 'active-link' : ''}`}>Destinations</a>
            <div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
              <Link to="/abu">Abu Dhabi</Link>
              <Link to="/dubai">Dubai</Link>
            </div>
          </div>
          <Link to="/hotels">Hotels</Link>
          <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
        </nav>
        <Link to="/booknow">
          <button className="contact-book-btn">Book Now</button>
        </Link>
      </header>

      <div className="Dubai-page">
        <div className="Dubai-hero">
          <div className="Dubai-hero-overlay">
            <h1>Explore Dubai</h1>
            <p>Skyscrapers, Deserts, and Luxury – The City of Gold Awaits</p>
          </div>
          <img src={dubaiBanner} alt="Dubai Banner" className="Dubai-hero-img" />
        </div>

        <section className="Dubai-info">
          <h2>Welcome to Dubai</h2>
          <p>
            Dubai is a city of superlatives, where modern architecture meets ancient traditions. From the world's tallest building and luxurious malls to thrilling desert safaris and historical souks, Dubai offers a unique blend of adventure, culture, and opulence.
          </p>
        </section>

        {Object.entries(dubaiData).map(([sectionTitle, items]) => (
          <section className="Dubai-section" key={sectionTitle}>
            <h2>{formatTitle(sectionTitle)}</h2>
            <div className="Dubai-cards-container">
              {items.map((item, index) => (
                <div className="Dubai-card" key={index}>
                  <img
                    src={imageMap[item.image] || item.image}
                    alt={item.name}
                  />
                  <h3>{item.name}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case 'Attractions': return 'Top Attractions';
    case 'Activities': return 'Must-Do Activities';
    case 'LuxuryResorts': return 'Luxury Resorts';
    case 'Culture': return 'Culture & Traditions';
    default: return key;
  }
};

export default Dubai;